module.exports = require('./components/dashboard');
